export const formatTime = (remainingTime: number): string => {
  const minutes: number = Math.floor(remainingTime / 60000);
  const seconds: number = Math.floor((remainingTime % 60000) / 1000);
  const formattedMinutes: string = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const formattedSeconds: string = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${formattedMinutes}:${formattedSeconds}`;
};


export const getSecondsDifference = (timestamp: Date) => {
  const givenTime = new Date(timestamp).getTime();
  if (!givenTime) return 0;
  const now = Date.now();
  const differenceInMilliseconds = givenTime - now;
  return Math.max(Math.floor(differenceInMilliseconds), 0);
};
